module.exports = __webpack_public_path__ + "img/error_404.45b2c29d.jpg";